<template>
  <AppModal v-model="isVisible" :close="closeModal">
    <div class="modal">
      <div class="modal--title">{{ $t('limitsModal.ranOutTitle') }} 😢</div>

      <div class="modal--subtitle">
        {{
          $t('limitsModal.availableGenerations', {
            count,
            total: downloadsLimit,
          })
        }}
      </div>

      <div class="modal--body">
        {{ $t('limitsModal.dontWorry') }}
        <span class="modal--body-timer">
          {{ $t('limitsModal.validFor') }} {{ formattedTime }}
        </span>
      </div>

      <div class="modal--promo" @click="copyPromoCode">
        <div class="modal--promo-code">{{ PROMO_CODE }}</div>
        <div class="modal--promo-discount">
          {{ $t('limitsModal.discountLabel') }}
        </div>
      </div>

      <AppButton class="modal--buyBtn" color="primary" @click="onPremiumClick">
        👑 {{ $t('limitsModal.buyPremium') }}
      </AppButton>
    </div>
  </AppModal>
</template>

<script>
import {
  EXTRA_DOWNLOADS_LIMIT,
  PART_PREMIUM_LIMIT,
  DOWNLOADS_LIMIT,
} from '@/../lib/commonConstants/common';
import { useAppStore } from '@/stores/useAppStore';
import { useUserStore } from '@/stores/useUserStore';
import { useToaster } from '@/../lib/utils/useToaster';

const PROMO_CODE = 'FREEUSER10';

export default {
  setup() {
    return {
      appStore: useAppStore(),
      userStore: useUserStore(),
      toaster: useToaster(),
    };
  },
  data() {
    return {
      PROMO_CODE,
      countdown: 300,
      timer: null,
      extraLimitGone: localStorage.getItem('isNewLimit'),
    };
  },
  computed: {
    isVisible() {
      return this.appStore.isModalLimitsVisible;
    },
    downloadsLimit() {
      if (this.userStore.hasPartPremium) {
        return PART_PREMIUM_LIMIT;
      }
      return this.extraLimitGone ? EXTRA_DOWNLOADS_LIMIT : DOWNLOADS_LIMIT;
    },
    count() {
      return this.userStore.user.limit;
    },
    formattedTime() {
      const m = Math.floor(this.countdown / 60);
      const s = this.countdown % 60;
      return `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
    },
  },
  watch: {
    isVisible(val) {
      if (val) {
        this.countdown = 300;
        this.startTimer();
      } else {
        this.stopTimer();
      }
    },
  },
  beforeUnmount() {
    this.stopTimer();
  },
  methods: {
    closeModal() {
      this.appStore.showModalLimitsVisible(false);
    },
    onPremiumClick() {
      this.$router.push({ name: 'pricing' });
      this.closeModal();
    },
    async copyPromoCode() {
      try {
        await navigator.clipboard.writeText(PROMO_CODE);
        this.toaster.success(this.$t('limitsModal.copiedToClipboard'));
      } catch {
        this.toaster.error(PROMO_CODE);
      }
    },
    startTimer() {
      this.stopTimer();
      this.timer = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown -= 1;
        } else {
          this.stopTimer();
        }
      }, 1000);
    },
    stopTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.modal {
  padding: 40px 20px 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  &--title {
    margin-bottom: 8px;
    font-size: 22px;
    font-weight: 700;
    color: #25262c;
    line-height: 130%;
  }

  &--subtitle {
    margin-bottom: 32px;
    font-size: 14px;
    font-weight: 500;
    color: #25262c80;
    text-transform: uppercase;
    letter-spacing: 0.02em;
  }

  &--body {
    margin-bottom: 24px;
    font-size: 16px;
    font-weight: 500;
    color: #25262c;
    line-height: 150%;

    &-timer {
      color: #2467ec;
      font-weight: 600;
    }
  }

  &--promo {
    width: 100%;
    margin-bottom: 24px;
    border-radius: 16px;
    overflow: hidden;
    cursor: pointer;
    transition: opacity 0.15s;

    &:hover {
      opacity: 0.85;
    }

    &:active {
      opacity: 0.7;
    }
  }

  &--promo-code {
    background: #dce3f5;
    padding: 20px 24px;
    font-size: 28px;
    font-weight: 800;
    letter-spacing: 0.06em;
    color: #25262c;
  }

  &--promo-discount {
    background: #c9d3ee;
    padding: 10px 24px;
    font-size: 14px;
    font-weight: 500;
    color: #25262c;
  }

  &--buyBtn {
    width: 100%;
    font-size: 16px;
    font-weight: 600;
  }
}
</style>
